export default function formatExperimentName(name: string | undefined | null): string {
  return name || "[Untitled]".trim();
}
